// language=GraphQL
export const ALL_TRAVEL_TYPES_BLOCKS_QUERY = `query Query {
  travelTypesBlocks: cmsTravelTypesBlocks {
    id
    layout
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_TYPES_BLOCK_QUERY = `query Query($id: ID!) {
  travelTypesBlock: cmsTravelTypesBlock(id: $id) {
    id
    layout
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_TYPES_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsTravelTypesBlockInput) {
    travelTypesBlock: createCmsTravelTypesBlock(input: $input) {
      id
      layout
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_TYPES_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsTravelTypesBlockInput) {
    travelTypesBlock: updateCmsTravelTypesBlock(input: $input) {
      id
      layout
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_TYPES_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTravelTypesBlockInput) {
    deleteCmsTravelTypesBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_TYPES_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTravelTypesBlockInput) {
    forceDeleteCmsTravelTypesBlock(input: $input) {
      success
    }
  }`
